
import { FORGOT_ENTER_EMAIL, FORGOT_PASSWORD_REQUESTING, FORGOT_PASSWORD_REQUEST_ERROR, FORGOT_PASSWORD_REQUESTED } from 'actions'

const initialState = {
  email: '',
  error: null,
  isRequesting: false,
  success: false
}

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FORGOT_ENTER_EMAIL:
      return {
        ...state,
        email: payload
      }
    case FORGOT_PASSWORD_REQUESTING:
      return {
        ...state,
        error: null,
        isRequesting: true,
        success: false
      }
    case FORGOT_PASSWORD_REQUEST_ERROR:
      return {
        ...state,
        error: payload.error,
        isRequesting: false,
        success: false
      }
    case FORGOT_PASSWORD_REQUESTED:
      return {
        ...state,
        error: null,
        isRequesting: false,
        success: true
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/application/forgot.js